import React from 'react';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import GenerateRoute from '../../components/GenerateRoutePage/GenerateRoute/GenerateRoute';

// GenerateRoutePage: page that renders both the Toolbar component and 
// the GenerateRoute component.
const GenerateRoutePage: React.FC = () => {
    return(
        <div className='pageContainer'>
            <Toolbar />
            <GenerateRoute />
        </div>
    );
};

export default GenerateRoutePage;